import React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';
import DailyGeneratedRakeChart from './DailyGeneratedRakeChart';
import PlayersPerDayChart from './PlayersPerDayChart';
import ParticipantsByTimeOfDayChart from './ParticipantsByTimeOfDayChart';
import RakeByGameTypeChart from './RakeByGameTypeChart';
import RakeByBuyInChart from './RakeByBuyInChart';
import ParticipantsByBuyInChart from './ParticipantsByBuyInChart';
import useTournamentOverviewStats from '@/hooks/useTournamentOverviewStats';

const SNGOverviewStats: React.FC<{
  fromDate: Date | null;
  toDate: Date | null;
}> = ({ fromDate, toDate }) => {
  const tournamentStats = useTournamentOverviewStats(fromDate?.toISOString(), toDate?.toISOString(), { sng: true });

  const charts = [
    {
      title: 'Daily Generated Sit & Go Tournaments Rake',
      data: tournamentStats?.dailyRake,
      ChartComponent: DailyGeneratedRakeChart,
    },
    {
      title: 'Sit & Go Players Per Day',
      data: tournamentStats?.dailyPlayers,
      ChartComponent: PlayersPerDayChart,
    },
    {
      title: 'Sit & Go Participants by Time of Day',
      data: tournamentStats?.participantsByTimeOfDay,
      ChartComponent: ParticipantsByTimeOfDayChart,
    },
    {
      title: 'Sit & Go Rake by Game Type',
      data: tournamentStats?.rakeByGameType,
      ChartComponent: RakeByGameTypeChart,
    },
    {
      title: 'Sit & Go Rake by Buy In',
      data: tournamentStats?.rakeByBuyIn,
      ChartComponent: RakeByBuyInChart,
    },
    {
      title: 'Sit & Go Participants by Buy In',
      data: tournamentStats?.participantsByBuyIn,
      ChartComponent: ParticipantsByBuyInChart,
    },
  ];

  return charts.map(
    ({
      title,
      data,
      ChartComponent,
    }: {
      title: string;
      data: any;
      ChartComponent: React.ComponentType<{ chartData: any }>;
    }) => (
      <Card key={title}>
        <CardHeader className="d-flex flex-rows justify-content-between align-middle">
          <h4 className="card-title mb-0">{title}</h4>
        </CardHeader>
        <CardBody>
          <ChartComponent chartData={data} />
        </CardBody>
      </Card>
    ),
  );
};

export default SNGOverviewStats;
